import { __assign } from "tslib";
// styles common to both the TileBadge and the FlyoutButtonBadge
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { BadgeSize } from './Constants';
export var useBadgeStyles = makeStyles({
    defaultBadge: {
        left: '20px',
        minWidth: '16px',
        maxWidth: '26px',
    },
    mercuryDesignBadge: {
        top: '9px',
        left: '26px',
    },
    badgeWide: __assign(__assign(__assign(__assign({ pointerEvents: 'none', top: '5px', left: '36px', minWidth: '16px', width: 'auto', height: BadgeSize, lineHeight: BadgeSize, position: 'absolute' }, shorthands.overflow('hidden')), { backgroundColor: tokens.colorPaletteDarkOrangeBackground3 }), shorthands.border(0)), { userSelect: 'none', fontSize: '10px' }),
    dotBadgeCommon: __assign(__assign(__assign(__assign({ pointerEvents: 'none', height: '8px', width: '8px', position: 'absolute' }, shorthands.overflow('hidden')), { userSelect: 'none', top: '6px', left: '42px' }), shorthands.border('1px', 'solid', tokens.colorSubtleBackground)), { backgroundColor: tokens.colorPaletteDarkOrangeBackground3 }),
    badgeReaderBox: __assign(__assign(__assign(__assign({ clip: 'rect(0px, 0px, 0px, 0px)', height: '1px' }, shorthands.margin('-1px')), shorthands.overflow('hidden')), shorthands.padding('0px')), { width: '1px', position: 'absolute' }),
    defaultDotBadge: {
        top: '6px',
        left: '28px',
    },
    mercuryDesignDotBadge: {
        top: '8px',
        left: '32px',
    },
    stringBadge: __assign({ backgroundColor: tokens.colorBrandBackground, fontSize: '8px' }, shorthands.padding('auto', '5px')),
    mercuryDesignWideBadge: {
        top: '9px',
        left: '18px',
    },
});
//# sourceMappingURL=Badge.styles.js.map